import { type Commands } from '../../../core/context/commands';
import { UUID } from '../../../core/context/uuid/entity';
import { AssetRelationTypes } from './repository';
import { AssetRelationType } from './entity';
import { type AssetRelationTypeData } from './dto';

export class AssetRelationTypesCommands
    implements
        Commands<AssetRelationTypes, AssetRelationType, AssetRelationTypeData>
{
    addAll(
        repo: AssetRelationTypes,
        data: AssetRelationTypeData[],
    ): AssetRelationTypes {
        data.forEach((assetRelationTypeData) => {
            this.add(repo, assetRelationTypeData);
        });
        return repo;
    }

    add(
        repo: AssetRelationTypes,
        data: AssetRelationTypeData,
    ): AssetRelationTypes {
        const assetRelationType = new AssetRelationType({
            id: data.id,
            name: data.name,
        });
        repo.add(assetRelationType);
        return repo;
    }

    update(
        repo: AssetRelationTypes,
        entity: AssetRelationType,
    ): AssetRelationType {
        repo.update(entity);
        return entity;
    }

    remove(repo: AssetRelationTypes, id: string): void {
        repo.remove(id);
    }

    create(
        repo: AssetRelationTypes,
        data: Omit<AssetRelationTypeData, 'id'>,
    ): AssetRelationType {
        const uuid = new UUID();
        const assetRelationType = new AssetRelationType({
            id: uuid.toString(),
            name: data.name,
        });
        repo.add(assetRelationType);
        return assetRelationType;
    }

    fromJSON(
        entity: AssetRelationType[],
        changeCallback: () => void,
    ): AssetRelationTypes {
        const newAssetRelationTypes = new AssetRelationTypes(changeCallback);
        entity.forEach((assetRelationType) => {
            newAssetRelationTypes.add(
                new AssetRelationType({
                    id: assetRelationType.id,
                    name: assetRelationType.name,
                }),
            );
        });
        return newAssetRelationTypes;
    }
}
